/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FanRemixContestEndedNotificationActionData
 */
export interface FanRemixContestEndedNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotificationActionData
     */
    entityUserId: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the FanRemixContestEndedNotificationActionData interface.
 */
export function instanceOfFanRemixContestEndedNotificationActionData(value: object): value is FanRemixContestEndedNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "entityUserId" in value && value["entityUserId"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndedNotificationActionDataFromJSON(json: any): FanRemixContestEndedNotificationActionData {
    return FanRemixContestEndedNotificationActionDataFromJSONTyped(json, false);
}

export function FanRemixContestEndedNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndedNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityUserId': json['entity_user_id'],
        'entityId': json['entity_id'],
    };
}

export function FanRemixContestEndedNotificationActionDataToJSON(value?: FanRemixContestEndedNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_user_id': value.entityUserId,
        'entity_id': value.entityId,
    };
}

